import { UUID } from '../core/context/uuid/entity';
import { MatrixValue } from '../core';

export enum MatrixValueGroup {
    Likelihood = 'Likelihood',
    Exposure = 'Exposure',
    Exploitability = 'Exploitability',
    Risk = 'Risk',
    Impact = 'Impact',
    Criticality = 'Criticality',
}

const likelihood = {
    veryUnlikely: new MatrixValue({
        id: new UUID().toString(),
        name: 'Very unlikely',
        color: '#1697f1',
        group: MatrixValueGroup.Likelihood,
    }),
    unlikely: new MatrixValue({
        id: new UUID().toString(),
        name: 'Unlikely',
        color: '#92cf55',
        group: MatrixValueGroup.Likelihood,
    }),
    possible: new MatrixValue({
        id: new UUID().toString(),
        name: 'Possible',
        color: '#ffe642',
        group: MatrixValueGroup.Likelihood,
    }),
    likely: new MatrixValue({
        id: new UUID().toString(),
        name: 'Likely',
        color: '#ffa229',
        group: MatrixValueGroup.Likelihood,
    }),
    veryLikely: new MatrixValue({
        id: new UUID().toString(),
        name: 'Very likely',
        color: '#f04a2d',
        group: MatrixValueGroup.Likelihood,
    }),
};

const exposure = {
    low: new MatrixValue({
        id: new UUID().toString(),
        name: 'Low',
        color: '#92cf55',
        group: MatrixValueGroup.Exposure,
    }),
    medium: new MatrixValue({
        id: new UUID().toString(),
        name: 'Medium',
        color: '#ffe642',
        group: MatrixValueGroup.Exposure,
    }),
    high: new MatrixValue({
        id: new UUID().toString(),
        name: 'High',
        color: '#f04a2d',
        group: MatrixValueGroup.Exposure,
    }),
};

const exploitability = {
    low: new MatrixValue({
        id: new UUID().toString(),
        name: 'Low',
        color: '#92cf55',
        group: MatrixValueGroup.Exploitability,
    }),
    medium: new MatrixValue({
        id: new UUID().toString(),
        name: 'Medium',
        color: '#ffe642',
        group: MatrixValueGroup.Exploitability,
    }),
    high: new MatrixValue({
        id: new UUID().toString(),
        name: 'High',
        color: '#f04a2d',
        group: MatrixValueGroup.Exploitability,
    }),
};
const risk = {
    minor: new MatrixValue({
        id: new UUID().toString(),
        name: 'Minor',
        color: '#92cf55',
        group: MatrixValueGroup.Risk,
    }),
    moderate: new MatrixValue({
        id: new UUID().toString(),
        name: 'Moderate',
        color: '#ffe642',
        group: MatrixValueGroup.Risk,
    }),
    significant: new MatrixValue({
        id: new UUID().toString(),
        name: 'Significant',
        color: '#ffa229',
        group: MatrixValueGroup.Risk,
    }),
    major: new MatrixValue({
        id: new UUID().toString(),
        name: 'Major',
        color: '#f04a2d',
        group: MatrixValueGroup.Risk,
    }),
};

const impact = {
    negligible: new MatrixValue({
        id: new UUID().toString(),
        name: 'Negligible',
        color: '#92cf55',
        group: MatrixValueGroup.Impact,
    }),
    moderate: new MatrixValue({
        id: new UUID().toString(),
        name: 'Moderate',
        color: '#ffe642',
        group: MatrixValueGroup.Impact,
    }),
    critical: new MatrixValue({
        id: new UUID().toString(),
        name: 'Critical',
        color: '#ffa229',
        group: MatrixValueGroup.Impact,
    }),
    disastrous: new MatrixValue({
        id: new UUID().toString(),
        name: 'Disastrous',
        color: '#f04a2d',
        group: MatrixValueGroup.Impact,
    }),
};

const criticalityValues = {
    low: new MatrixValue({
        id: new UUID().toString(),
        name: 'Low',
        color: '#92cf55',
        group: MatrixValueGroup.Criticality,
    }),
    medium: new MatrixValue({
        id: new UUID().toString(),
        name: 'Medium',
        color: '#ffe642',
        group: MatrixValueGroup.Criticality,
    }),
    high: new MatrixValue({
        id: new UUID().toString(),
        name: 'High',
        color: '#f04a2d',
        group: MatrixValueGroup.Criticality,
    }),
};

export const likelihoodMatrix = {
    horizontal: [exposure.low.id, exposure.medium.id, exposure.high.id],
    vertical: [
        exploitability.low.id,
        exploitability.medium.id,
        exploitability.high.id,
    ],
    values: [
        [
            likelihood.veryUnlikely.id,
            likelihood.unlikely.id,
            likelihood.possible.id,
        ],
        [likelihood.unlikely.id, likelihood.possible.id, likelihood.likely.id],
        [
            likelihood.possible.id,
            likelihood.likely.id,
            likelihood.veryLikely.id,
        ],
    ],
};

export const riskMatrix = {
    horizontal: [
        likelihood.veryUnlikely.id,
        likelihood.unlikely.id,
        likelihood.possible.id,
        likelihood.likely.id,
        likelihood.veryLikely.id,
    ],
    vertical: [
        impact.negligible.id,
        impact.moderate.id,
        impact.critical.id,
        impact.disastrous.id,
    ],
    values: [
        [
            risk.minor.id,
            risk.minor.id,
            risk.minor.id,
            risk.minor.id,
            risk.moderate.id,
        ],
        [
            risk.minor.id,
            risk.moderate.id,
            risk.moderate.id,
            risk.moderate.id,
            risk.significant.id,
        ],
        [
            risk.minor.id,
            risk.moderate.id,
            risk.moderate.id,
            risk.significant.id,
            risk.major.id,
        ],
        [
            risk.moderate.id,
            risk.moderate.id,
            risk.significant.id,
            risk.major.id,
            risk.major.id,
        ],
    ],
};

export const matrixValues = [
    ...Object.values(risk),
    ...Object.values(impact),
    ...Object.values(criticalityValues),
    ...Object.values(exposure),
    ...Object.values(exploitability),
    ...Object.values(likelihood),
];
